export default {
  getCookie(name) {
    const value = `; ${document.cookie}`;
    return value.split(`; ${name}=`).pop().split(';').shift();
  },

  setCookie(name = '', value = '', path = '/', exp = '') {
    const cookieString = `${name}=${value};path=${path};expires=${exp}`;
    document.cookie = cookieString;
  },
};
